import React, { useState, useEffect } from "react";
import styles from "./ImageWithModal.module.css";
import { t } from "i18next";

interface ImageWithModalProps {
  src: string;
  alt?: string;
  width?: string;
  height?: string;
}

export const ImageWithModal: React.FC<ImageWithModalProps> = ({
  src,
  alt = "",
  width = "-webkit-fill-available",
  height = "auto",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <>
      <div
        className={styles.thumbnailContainer}
        style={{ width, height }}
        onClick={openModal}
      >
        {/* <img src={src} alt={alt} className={styles.thumbnail} /> */}
        <img src={src} alt={alt} className={styles.expandButton}></img>
        <div className={styles.hoverText}>
          {t("alternate_product.image_text")}
        </div>
      </div>

      {isOpen && (
        <div className={styles.modalBackdrop} onClick={closeModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <img src={src} alt={alt} className={styles.fullImage} />
            <button className={styles.closeButton} onClick={closeModal}>
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
};
